




<!-- SECTION -->
<div class="section">
  <!-- container -->
  <div class="container">
    <!-- row -->
    <div class="row">

      <!-- section title -->
      <!-- <div class="col-md-12" *ngIf="products && products.length">
        <div class="section-title text-center">
          <h3 class="title">{{ categoryName | titlecase }}</h3>
        </div>
      </div> -->

      <div class="col-md-12 section mcb-section mfn-default-section mcb-section-e71f387ac default-width" *ngIf="products && products.length">
        <div class="mcb-background-overlay"></div>
        <div class="section_wrapper mcb-section-inner mcb-section-inner-e71f387ac">
          <div class="wrap mcb-wrap mcb-wrap-g6b8km2fu one tablet-one mobile-one clearfix" data-desktop-col="one"
            data-tablet-col="tablet-one" data-mobile-col="mobile-one">
            <div class="mcb-wrap-inner mcb-wrap-inner-g6b8km2fu">
              <div class="mcb-wrap-background-overlay"></div>
              <div class="column mcb-column mcb-item-icj0pshk one-second tablet-one-second mobile-one column_shop_title"
                >
                <div class="mcb-column-inner mcb-column-inner-icj0pshk mcb-item-shop_title-inner">
                  <h1 class="woocommerce-products-header__title page-title">{{ categoryName | titlecase }}</h1>
                </div>
              </div>
              <div class="column mcb-column mcb-item-qf9v30dsa one-second tablet-one-second mobile-one column_image" style="">
                <div class="mcb-column-inner mcb-column-inner-qf9v30dsa mcb-item-image-inner">
                  <div class="image_frame element_classes image_item no_link scale-with-grid alignnone no_border">
                    <div class="image_wrapper"><img class="scale-with-grid"
                        src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-shop-pic1.webp"
                        alt="furniturestore-shop-pic1" title="" width="780" height="482" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /section title -->

      <!-- Products tab & slick -->
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4 col-sm-6" *ngFor="let p of products">
            <div class="card my-2">
              <img [src]="imageBaseUrl + p.image" alt="{{p.name}}" width="200px" class="card-img-top" style="cursor: pointer;"
                (click)="selectProduct(getSlug(p.name + ' ' + p.id))">
              <div class="card-header">
                <div class="card-title">
                  <p>{{p.name | titlecase}}</p>
                </div>
              </div>
              <div class="card-body">
                <h6>{{p.description.substr(0, 65)}} ...</h6>
                <p class="lead">{{p.price | currency: 'INR'}}</p>
              </div>
              <div class="row d-flex justify-content-center border-primary my-3">
                <div class="col-md-6">
                  <button class="btn btn-outline-primary btn-sm btn-block" [class.disabled]="p.quantity < 1"
                    [class.btn-outline-danger]="p.quantity < 1" (click)="AddToCart(p.id)">
                    {{
                    p.quantity < 1 ? "SOLD OUT" : "Add to Cart" }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Products tab & slick -->
      </div>
      <!-- /row -->
    </div>
  </div>
</div>
<!-- /SECTION -->



